import * as React from 'react';

import classNames from 'classnames';

import { getConfig, URLS, TOP_MENU_ID } from '@constants';

import { IconNotifications, IconMessages } from '@base/assets/icons';
import { isMobileScreen, translations } from '@base/utils';

import { BurgerButton } from '@ui/BurgerButton';

import { Logo } from '../Logo';
import { TopMenuBalance } from '../TopMenuBalance';
import { TopMenuIconLink } from '../TopMenuIconLink';

import s from './Header.scss';

export interface IHeaderProps {
	refProp: React.RefObject<HTMLDivElement>;
	className?: string;
	isBurgerInBackState?: boolean;
	counters?: {
		notifies?: number;
		dialogues?: number;
	};
	onBurgerBtnClick?(): void;
	pageTitle?: string;
	isShowIcons?: boolean;
	isTransparent?: boolean;
	isShownMenu?: boolean;
	balance: number;
}

export const Header = (props: IHeaderProps) => {
	const {
		className,
		counters: { notifies, dialogues },
		isBurgerInBackState,
		onBurgerBtnClick,
		isShowIcons,
		isTransparent,
		isShownMenu,
		balance,
	} = props;
	const { holidaysConfig, defaultLogoUrl } = getConfig();
	const logoUrl = holidaysConfig.logoUrl || defaultLogoUrl;

	return <div
		id={TOP_MENU_ID}
		ref={props.refProp}
		className={
			classNames(
				s.block,
				{ [s.blockTransparent]: (isTransparent && isMobileScreen()) },
				className,
			)}
	>
		<Logo className={s.logo} src={logoUrl} />
		<div className={s.titleWrapper}>
			<BurgerButton
				isShownMenu={isShownMenu}
				isBackState={isBurgerInBackState}
				onClick={onBurgerBtnClick}
			/>
		</div>
		{isShowIcons && <div className={classNames(s.item, s.icons)}>
			<TopMenuIconLink
				url={URLS.NOTIFICATIONS}
				icon={IconNotifications}
				title={translations.common('notifications')}
				notify={notifies}
			/>
			<TopMenuIconLink
				url={URLS.DIALOGUES}
				icon={IconMessages}
				title={translations.common('dialogues')}
				notify={dialogues}
			/>
			<TopMenuBalance balance={balance} />
		</div>}
	</div>;
};
